export const Appliances = [
    {
        key: 'microwave',
        i18n: 'microwave',
        desc: '1400W/30Mins/day',
        icon: '/img/calculators/mm100/appliance_microwave.svg',
        power: 1400,
        time: { h: '00', m: '30', t: 0.5 },
    },
    {
        key: 'crockpot',
        i18n: 'crockpot',
        desc: '250W/2Hours/day',
        icon: '/img/calculators/mm100/appliance_crockpot.svg',
        power: 250,
        time: { h: '02', m: '00', t: 2 },
    },
    {
        key: 'water_heater',
        i18n: 'water_heater',
        desc: '1800W/30Mins/day',
        icon: '/img/calculators/mm100/appliance_heater.svg',
        power: 1800,
        time: { h: '00', m: '30', t: 0.5 },
    },
    {
        key: 'air_conditioner',
        i18n: 'air_conditioner',
        desc: '2400W/6Hours/day',
        icon: '/img/calculators/mm100/appliance_air.svg',
        power: 2400,
        time: { h: '06', m: '00', t: 6 },
    },
    {
        key: 'laptop',
        i18n: 'laptop',
        desc: '120W/6Hours/day',
        icon: '/img/calculators/mm100/appliance_laptop.svg',
        power: 120,
        time: { h: '06', m: '00', t: 6 },
    },
    {
        key: 'tv',
        i18n: 'tv',
        desc: '110W/8Hours/day',
        icon: '/img/calculators/mm100/appliance_tv.svg',
        power: 110,
        time: { h: '08', m: '00', t: 8 },
    },
    {
        key: 'induction_cooker',
        i18n: 'induction_cooker',
        desc: '1800W/1Hour30Mins/day',
        icon: '/img/calculators/mm100/appliance_cooker.svg',
        power: 1800,
        time: { h: '01', m: '30', t: 1.5 },
    },
    {
        key: 'fridge',
        i18n: 'fridge',
        desc: '200W/24Hours/day',
        icon: '/img/calculators/mm100/appliance_fridge.svg',
        power: 200,
        time: { h: '24', m: '00', t: 24 },
    },
    {
        key: 'light',
        i18n: 'light',
        desc: '10W/16Hours/day',
        icon: '/img/calculators/mm100/appliance_light.svg',
        power: 10,
        time: { h: '16', m: '00', t: 16 },
    },
    // { key: 10, i18n: 'custome', icon: '/img/calculators/mm100/appliance_custom.svg' },
];

// 计算公式
export const calculateTotalPower = (allArr: any, selectedArr: any) => {
    let result = 0;
    allArr?.map((app: any) => {
        if (selectedArr.find((item: any) => item.key === app.key)) {
            if (['air_conditioner', 'fridge'].includes(app.key)) {
                result += (app.power * app.time.t) / 2;
            } else {
                result += app.power * app.time.t;
            }
        }
    });
    return result / 1000;
};
